<template>
  <div class="interactive">
    <section>
      <p class="line el-button--primary forbid-hover-status"></p>
      <div class="like-section" v-if="likeCount > 0">
        <template v-if="loginUser">
          <span class="like-button el-button--text" v-if="loginUser.liked" @click="liked">
            <i class="iconfont icon--goods"></i>{{likeCount}}
          </span>
          <span class="like-button el-button--text" v-else @click="likeAction">
            <i class="iconfont icon--good"></i>{{likeCount}}
          </span>
        </template>
        <template v-else>
          <span class="like-button el-button--text" @click="likeAction">
            <i class="iconfont icon--good"></i>{{likeCount}}
          </span>
        </template>
        <div class="img-wrap">
          <ul class="wechat-avatar-list">
            <li
              v-for="(item, index) in likes"
              :key="index"
              class="item"
              :class="[index > 9 && hidden ? 'hidden' : '']">
              <div class="img-wrap">
                <img :src="item.user.avatar" alt="" class="avatar">
              </div>
            </li>
          </ul>
          <template v-if="likes && likes.length > 10">
            <div class="show-more">
              <template v-if="hidden">
                <el-button type="text" @click="hidden = false">查看更多<i class="iconfont icon--arrow"></i></el-button>
              </template>
              <template v-else>
                <el-button type="text" @click="hidden = true">收起<i class="iconfont icon--arrow-up"></i></el-button>
              </template>
            </div>
          </template>
        </div>
      </div>
    </section>
    <section>
      <div class="visitor-section">
        <p class="el-button--text forbid-hover-status message">最近访客（{{visiteCount}}）</p>
        <ul class="wechat-list">
          <li v-for="(item, index) in visits" class="item" :key="index">
            <template v-if="parseInt(item.user_id) > 0 && parseInt(item.user_id) !== id">
              {{item.nickname}}
            </template>
            <template v-else>
              {{item.city || item.region || item.country}}的学者
            </template>
            <span class="gray">访问了主页</span><span class="pull-right gray">{{item.time}}</span>
          </li>
        </ul>
        <div class="show-more" v-if="lastPage > 1">
          <template v-if="currentPage < lastPage">
            <el-button type="text" @click="getMore" :loading="loading">查看更多<i class="iconfont icon--arrow"></i></el-button>
          </template>
          <template v-else>
            <el-button type="text" @click="hideMore">收起<i class="iconfont icon--arrow-up"></i></el-button>
          </template>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { getPageData } from '@/api/index'
import { Toast } from 'mint-ui'
export default {
  props: {
    likeCount: Number,
    visiteCount: Number,
    likes: Array,
    visitLogs: Object,
    loginUser: Object,
    isMobile: Boolean,
    id: Number,
    groupList: Array
  },
  data () {
    return {
      visits: this.visitLogs.data,
      currentPage: parseInt(this.visitLogs.current_page),
      lastPage: parseInt(this.visitLogs.last_page),
      hidden: true,
      loading: false
    }
  },
  methods: {
    getMore () {
      this.loading = true
      let id = this.$route.params.id
      getPageData(id, {
        page: this.currentPage + 1
      })
        .then((res) => {
          if (res.code === 1) {
            this.visits = [...this.visits, ...res.data.data]
            this.currentPage = res.data.current_page
            this.lastPage = res.data.last_page
          } else {
            this.$message.error(res.message)
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
        })
    },
    hideMore () {
      let id = this.$route.params.id
      getPageData(id, {
        page: 0
      })
        .then((res) => {
          if (res.code === 1) {
            this.visits = res.data.data
            this.currentPage = res.data.current_page
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    likeAction () {
      this.$emit('likeAction')
    },
    liked () {
      if (this.isMobile) {
        Toast('您已经点过赞啦')
      } else {
        this.$message('您已经点过赞啦')
      }
    }
  }
}
</script>
<style scoped lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/Index/Interactive/index.vue